export const WorkplaceViolenceOptions = [
    { name: 'PatientBehavior', description: 'Patient Behavior' },
    { name: 'VisitorBehavior', description: 'Visitor Behavior' },
    { name: 'StaffBehavior', description: 'Staff Behavior' },
    { name: 'Other', description: 'Other' },
];
